exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "installation-prompt {\n  display: -webkit-box;\n  display: flex;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"plugins":[{}]}!./src/app/common/components/installation-prompt/installation-prompt.component.less
// module id = Lgt2
// module chunks = 1